import styled, { css } from 'styled-components';

import { screens } from 'ggApp/utils/mixins/screens';
import Typography from '../../../typography';
import NavigationLink from '../../../../common/NavigationLink';

const navigationLinkStyles = css`
    text-decoration: none;
    &:hover,
    &:focus,
    &:active {
        cursor: pointer;
        color: ${({ theme }) => theme.colors.Foreground};
    }
`;

const categoryBackgroundColor = css`
    background-color: #f7f7f7;
`;

export const WidgetWrapper = styled.div`
    grid-column: 1 / -1;

    @media (${screens.phone}) and (${screens.tabletMax}) {
        margin: ${({ theme }) => theme.spacers.XXL} 0 ${({ theme }) => theme.spacers.XXL} 0;
        padding-right: 0;
    }

    @media (${screens.tablet}) {
        margin: ${({ theme }) => theme.spacers.XXL} ${({ theme }) => theme.spacers.L};
    }

    @media (${screens.desktop}) {
        margin: ${({ theme }) => theme.spacers.XXL} 5% ${({ theme }) => theme.spacers.XXL};
    }
`;

export const WidgetTitle = styled.span`
    display: inline-block;
    ${({ theme }) => theme.typography.Subheadline};
    margin-bottom: ${({ theme }) => theme.spacers.XL};

    @media (${screens.phone}) and (${screens.tabletMax}) {
        margin-bottom: ${({ theme }) => theme.spacers.L};
        margin-left: ${({ theme }) => theme.spacers.L};
    }
`;

export const CategoryWrapper = styled.div(
    ({ theme }) => `
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    grid-column-gap: ${theme.spacers.L};
    grid-row-gap: ${theme.spacers.L};

    @media (${screens.tablet}) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    @media (${screens.desktop}) {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    @media (${screens.largeDesktop}) {
        grid-template-columns: repeat(6, minmax(0, 1fr));
    }
`,
);

export const Category = styled(NavigationLink)`
    ${categoryBackgroundColor};
    grid-column: auto / span 2;
    border-radius: 8px;
    height: 176px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${({ theme }) => theme.spacers.L};
    ${navigationLinkStyles};

    @media (${screens.tablet}) {
        grid-column: auto / span 1;
        padding: ${({ theme }) => theme.spacers.M};
    }

    @media (${screens.desktop}) {
        grid-column: auto / span 1;
        padding: ${({ theme }) => theme.spacers.L};
    }
`;

export const ImageWrapper = styled.div`
    width: 120px;
    height: 120px;
    margin-bottom: ${({ theme }) => theme.spacers.M};

    @media (${screens.phone}) and (${screens.tabletMax}) {
        height: auto;
        align-self: center;
        margin-bottom: 0;
    }
`;

export const Image = styled.img`
    align-self: center;
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

export const CategoryName = styled(Typography)`
    color: ${({ theme }) => theme.colors.secondary};
    line-height: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;

    @media (${screens.phone}) and (${screens.tabletMax}) {
        font-size: 14px;
    }

    @media (${screens.tablet}) {
        max-width: 160px;
    }

    @media (${screens.desktop}) {
        min-width: 100%;
    }
`;

export const MobileCategoryWrapper = styled.div`
    display: flex;
    overflow-x: scroll;
    ::-webkit-scrollbar {
        height: 0;
        width: 0;
        background: transparent;
    }
`;

export const MobileCategory = styled(NavigationLink)`
    ${categoryBackgroundColor};
    margin-right: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 ${({ theme }) => theme.spacers.M} 12px ${({ theme }) => theme.spacers.M};
    min-width: max-content;
    border-radius: 8px;

    :first-child {
        margin-left: ${({ theme }) => theme.spacers.L};
    }
`;
